import { useCallback } from "react";
import { toast } from "sonner";
import { authClient, useAuth } from "@/auth";

export function useSendVerificationEmail() {
	const { user } = useAuth();

	return useCallback(async () => {
		return authClient.sendVerificationEmail({
			email: user.email,
			callbackURL: `${window.location.origin}/dashboard?success=verify-email`,
			fetchOptions: {
				onSuccess() {
					toast.success("Verification email sent! Please check your inbox.");
				},
				onError() {
					toast.error("Failed to resend verification email. Please try again.");
				},
			},
		});
	}, [user.email]);
}
